(function () {
    'use strict';

    angular.module("imApp").factory("stockBatchListService", ['$ihttp', function ($ihttp) {
        let service = {
            listStockBatches: function (parms) {
                return $ihttp.post({
                    method: 170,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
